import React, { Fragment, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import useVerticalScroll from "../../hooks/useVerticalScroll";
import UIMainLogo from "../atoms/UIMainLogo";
import UIBurguerMenuIcon from "../atoms/UIBurguerMenuIcon";

export default function UINavbarOut() {
  const [isOpen, setIsOpen] = useState(false);
  const {pathname} = useLocation()
  const scrollY = useVerticalScroll();

  function handleMenuToggle() { setIsOpen(!isOpen); }

  return (
    <Fragment>
      <header className={`absolute font-OpenSans z-[9999] px-[10%] transition-height  w-full flex items-center justify-between py-4  bg-white  ${!isOpen && 'shadow-md'}`}
        style={{ transition: 'height 500ms', height: "75px", position: scrollY < 700 ? "fixed" : "absolute", top: scrollY > 700 ? "700px" : "0" }}
      >
        <div className="flex flex-row items-center">
          <UIMainLogo />
        </div>
        <div className="content-center text-[16px] gap-6 hidden md:flex">
          <Link to="/" className="w-auto py-2 text-[#2D2D2D] hover:text-gray-900">Inicio</Link>
          <Link to="/preguntas-frecuentes" className="w-auto py-2 text-[#2D2D2D] hover:text-gray-900">Preguntas frecuentes</Link>
          <Link to="/inicio-sesion" className="w-auto py-2 text-[16px]  text-[#2D2D2D] hover:text-gray-900">Iniciar sesión</Link>
         {pathname !== "/registro" && (<Link className="px-8 py-2 text-base flex items-center justify-center font-BNPPSquareBold text-white transition-all bg-primary rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-700 focus:ring-opacity-50 "
            to="/registro">REGÍSTRATE
          </Link>)}
          
        </div>
        <div className="md:hidden">
          <div className="p-2 rounded-md focus:outline-none" onClick={handleMenuToggle}>
            <UIBurguerMenuIcon isOpen={isOpen} />
          </div>
        </div>
      </header>
      {
        isOpen && (
          <div className="fixed bottom-0 top-[75px] px-[15%] duration-500 animate-appear-top pt-[32px] flex flex-col gap-2 left-0 z-[9998] w-full bg-white shadow-lg ">
            <Link to="/" className="block py-2 text-gray-800" onClick={() => setIsOpen(false)}>Inicio</Link>
            <Link to="/preguntas-frecuentes" className="block py-2 text-gray-800" onClick={() => setIsOpen(false)}>Preguntas frecuentes</Link>
            <Link to="/inicio-sesion" className="block py-2 text-gray-800" onClick={() => setIsOpen(false)}>Iniciar sesión</Link>
            {pathname !== "/registro" && (  <Link to="/registro" className="px-8 py-3 mt-6 text-[14px] flex items-center justify-center text-white transition-all bg-primary rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-700 focus:ring-opacity-50" onClick={() => setIsOpen(false)}>REGÍSTRATE</Link>)}
          </div>
        )
      }
      <div style={{ height: "75px" }}></div>
    </Fragment >
  );
}
